import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import useGalleryStyle from '../../styles/GalleryStyles.jsx';
import Photo from './Photo.jsx';

import photos from './photos';

const Gallery = ({ theme, isMobile }) => {
  const {
    root,
    header,
    text,
    gallery,
  } = useGalleryStyle();

  return (
    <Box className={root}>
      <Typography className={header}>
        Gallery
      </Typography>

      <Typography className={text}>
        Always on the way &#10084;
      </Typography>
      <Box className={gallery}>
        {photos.map(
          (p, idx) => <Photo
            size={p.size}
            key={idx}
            src={p.photo}
            theme={theme}
            isMobile={isMobile} />,
        )}
      </Box>

    </Box>
  );
};

Gallery.propTypes = {
  theme: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Gallery;
